<template>
  <video :key="coverUrl" width="100%" controls="true" preload="metadata" :poster="coverSrc" class="video-files">
    <source :src="fileUrl" />
  </video>
</template>

<script>
import { getCoverSrc } from '@/components/common/VideoPlayer/utils';

export default {
  name: 'VideoFiles',
  props: {
    fileUrl: {
      type: String,
      default: '',
      required: true,
    },
    coverUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    coverSrc() {
      if (this.coverUrl && this.coverUrl.startsWith('http')) {
        return getCoverSrc(this.coverUrl);
      }

      return this.coverUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-files {
  background: var(--black);
  object-fit: contain;
  outline: none;
  height: 100%;
  max-height: 280px;
  flex-grow: 1;
}
</style>
